import React from 'react';
export function CertificationsBar() {
  const certs = [{
    icon: '🌿',
    text: '100% Natural'
  }, {
    icon: '🌱',
    text: 'Sin Gluten'
  }, {
    icon: '🚫',
    text: 'Sin Azúcar Añadida'
  }, {
    icon: '🧬',
    text: 'Sin GMO'
  }, {
    icon: '🌎',
    text: 'Ingredientes del Amazonas'
  }, {
    icon: '✅',
    text: 'Calidad ElixirX Certificada'
  }, {
    icon: '🏭',
    text: 'BPA Free'
  }];
  return <div className="bg-[#1B5E20] py-6 border-y border-[#0D3B12] overflow-hidden" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        {/* Scrollable on mobile, flex wrap on desktop */}
        <div className="flex overflow-x-auto hide-scrollbar pb-2 -mb-2 sm:pb-0 sm:mb-0 sm:flex-wrap justify-start sm:justify-center gap-6 sm:gap-10" data-id="element-23">
          {certs.map((cert, index) => <div key={index} className="flex items-center whitespace-nowrap text-white/90 font-medium text-sm sm:text-base shrink-0" data-id="element-24">
              <span className="mr-2 text-lg" data-id="element-25">{cert.icon}</span>
              {cert.text}
            </div>)}
        </div>
      </div>
    </div>;
}